import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {NgIf} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-embedded-loader',
  standalone: true,
  imports: [
    MatIconModule,
    NgIf,
    MatProgressSpinnerModule
  ],
  template: `
    <div class="d-flex flex-column align-items-center" style="gap: 24px">
      <div class="color-black-700 font-medium text-xl text-center">{{ title }}</div>
      <div style="position: relative; display: flex; align-items: center; justify-content: center;">
        <mat-spinner diameter="100" color="primary" strokeWidth="4"></mat-spinner>
        <img *ngIf="image" 
             [src]="image" 
             alt="AI" 
             width="32"
             height="32"
             style="position: absolute;">
      </div>
      <div class="d-flex flex-column align-items-center" style="gap: 8px">
        <div [innerHTML]="textContent" class="color-black-500 font-normal text-base text-center"></div>
        <span *ngIf="countdown" class="color-black-500 font-normal text-base text-center">{{ countdownText }}{{ countdown }} second{{ countdown > 1 ? 's' : '' }}</span>
      </div>
    </div>
  `
})
export class EmbeddedLoaderComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() textContent = '';
  @Input() image = '';
  @Input() countdown?: number;
  @Input() countdownText = 'Estimated time remaining: ';
  
  private countdownInterval?: NodeJS.Timeout;

  ngOnInit(): void {
    if (this.countdown) {
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  private startCountdown() {
    if (this.countdown) {
      this.countdownInterval = setInterval(() => {
        if (this.countdown && this.countdown > 1) this.countdown--;
      }, 1000);
    }
  }

  private stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = undefined;
    }
  }
}